<template>
  <div class="carousel">
    <el-carousel indicator-position="outside" height="350px">
      <el-carousel-item v-for="(item, index) in carouselImg" :key="index">
        <img :src="item" alt="" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carouselImg: [ require('../assets/images/1.jpg') ]
    }
  }
}
</script>
<style lang="scss" scoped>
 .carousel {
  width: 1400px;
  margin: 0 auto;
}
.el-carousel__item {
  img {
    width: 100%;
    height: 100%;
  }
}
.el-carousel--horizontal {
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>
